import { Badge } from '../ui/badge';
import { PlayCircle } from 'lucide-react';

export function VideoDemoSection({ content, theme, t }) {
  if (!content.video?.enabled) return null;

  return (
    <section key="video" id="demo" data-section="video_demo" className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <Badge className="bg-[#007a33] text-white border-[#007a33] mb-4 px-4 py-1 hover:bg-[#007a33] text-[0.7rem] font-black tracking-[1px]">
            {content.video.badge || 'PRODUCT DEMO'}
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4">{content.video.title || 'See It In Action'}</h2>
          <p className={`${t.textSecondary} text-lg max-w-2xl mx-auto`}>{content.video.subtitle || 'Watch how Grassroots Coaching can transform your team management'}</p>
        </div>
        <div className={`relative rounded-2xl overflow-hidden ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} ${t.borderSecondary} border shadow-2xl`}>
          {content.video.youtubeId ? (
            <div className="aspect-video">
              <iframe
                src={`https://www.youtube.com/embed/${content.video.youtubeId}?rel=0&modestbranding=1`}
                title="Product Demo"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
          ) : content.video.vimeoId ? (
            <div className="aspect-video">
              <iframe
                src={`https://player.vimeo.com/video/${content.video.vimeoId}?title=0&byline=0&portrait=0`}
                title="Product Demo"
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
                className="w-full h-full"
              />
            </div>
          ) : (
            <div className={`aspect-video flex items-center justify-center ${theme === 'dark' ? 'bg-gradient-to-br from-gray-800 to-gray-900' : 'bg-gradient-to-br from-[#007a33]/5 to-[#007a33]/10'}`}>
              <div className="text-center">
                <div className={`w-20 h-20 rounded-full ${theme === 'dark' ? 'bg-[#007a33]/20 hover:bg-[#007a33]/30' : 'bg-[#007a33]/10 hover:bg-[#007a33]/20'} flex items-center justify-center mx-auto mb-4 cursor-pointer transition-colors`}>
                  <PlayCircle className={`w-12 h-12 ${t.accentText}`} />
                </div>
                <p className={t.textSecondary}>Video coming soon</p>
              </div>
            </div>
          )}
        </div>
        {content.video.caption && (
          <p className={`text-center ${t.textMuted} text-sm mt-4`}>{content.video.caption}</p>
        )}
      </div>
    </section>
  );
}
